"use client";
import { useState } from "react";
import CareerInput from "./career-input";

export default function CareerForm() {
  const [resumeFiles, setResumeFiles] = useState([]);
  const [coverLetterFiles, setCoverLetterFiles] = useState([]);
  const [resumePreviewUrls, setResumePreviewUrls] = useState([]);
  const [coverLetterPreviewUrls, setCoverLetterPreviewUrls] = useState([]);

  const fileSelectedHandler = (event, setFiles, setPreviewUrls) => {
    const files = Array.from(event.target.files);
    setFiles(files);

    const fileReaders = [];
    const urls = [];
    files.forEach((file) => {
      const fileReader = new FileReader();
      fileReaders.push(fileReader);

      fileReader.onload = () => {
        urls.push(fileReader.result);
        if (urls.length === files.length) {
          setPreviewUrls(urls);
        }
      };

      fileReader.readAsDataURL(file);
    });
  };

  return (
    <div className="flex flex-col gap-3 py-10 rounded-md ">
      {/* <div>
        <h1 className="text-3xl text-gray-600 font-normal">
          Apply for this job
        </h1>
        <p className="text-sm font-thin">
          <span className="text-red-500 px-1 font-medium">*</span>Indicates a
          required field
        </p>
      </div> */}
      {/* <div className="flex gap-2 flex-wrap">
        <CareerInput placeholder="First Name" required />
        <CareerInput placeholder="Last Name" required />
      </div> */}
      {/* <div className="flex gap-2 flex-wrap">
        <CareerInput placeholder="Email" required />
        <CareerInput placeholder="Phone Number" required />
      </div> */}

      {/* <div className="flex gap-2 flex-wrap">
        <div className="flex flex-col items-start">
          <p className="font-semibold text-sm text-gray-600 mb-2">Resume/CV</p>
          <label
            className="flex items-center justify-center w-[20rem] h-[3rem] 
                          rounded-md bg-transparent text-black border border-blue-500 cursor-pointer
                         hover:bg-blue-500 hover:text-white transition-all duration-300 text-center"
          >
            <input
              type="file"
              accept="*"
              multiple
              onChange={(e) =>
                fileSelectedHandler(e, setResumeFiles, setResumePreviewUrls)
              }
              className="hidden"
            />
            Attach Resume
          </label>
          {resumeFiles.length > 0 && (
            <div className="w-full mt-4">
              <ul className="text-gray-800">
                {resumeFiles.map((file, index) => (
                  <li key={index}>{file.name}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="flex flex-col items-start">
          <p className="font-semibold text-sm text-gray-600 mb-2">
            Cover Letter
          </p>

          <label
            className="flex items-center justify-center w-[20rem] h-[3rem] 
                          rounded-md bg-transparent text-black border border-blue-500 cursor-pointer
                         hover:bg-blue-500 hover:text-white transition-all duration-300 text-center"
          >
            <input
              type="file"
              accept="*"
              multiple
              onChange={(e) =>
                fileSelectedHandler(
                  e,
                  setCoverLetterFiles,
                  setCoverLetterPreviewUrls,
                )
              }
              className="hidden"
            />
            Attach Cover Letter
          </label>
          {coverLetterFiles.length > 0 && (
            <div className="w-full mt-4">
              <ul className="text-gray-800 ">
                {coverLetterFiles.map((file, index) => (
                  <li key={index}>{file.name}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div> */}
      {/* <span className="text-gray-400 text-sm font-light">
        Enter manually Accepted file types: pdf, doc, docx, txt, rtf
      </span> */}
      {/* <div className="border-b py-10">
        <div className="md:w-[40rem] border p-2 rounded-md my-2">
          <p className="font-semibold text-xs md:text-sm text-gray-500 mb-2">
            Are you legally authorized to work in the United States?
            <span className="text-red-500 px-1">*</span>
          </p>
          <select className="md:w-[30rem] appearance-none rounded-md p-2">
            <option>Select...</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </div>
        <div className="md:w-[40rem] border p-2 rounded-md my-2">
          <p className="font-semibold text-sm text-gray-500 mb-2">
            Will you now, or in the future, require sponsorship for employment
            visa status (e.g. H-1B visa status)?
            <span className="text-red-500 px-1">*</span>
          </p>
          <select className="md:w-[30rem] appearance-none rounded-md p-2">
            <option>Select...</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </div>
        <div className="md:w-[40rem] border p-2 rounded-md my-2">
          <p className="font-semibold text-sm text-gray-500 mb-2">
            Where are you currently based?
            <span className="text-red-500 px-1">*</span>
          </p>
          <input className="md:w-[30rem]" />
        </div>
        <div className="md:w-[40rem] border p-2 rounded-md my-2">
          <p className="font-semibold text-sm text-gray-500 mb-2">
            When can you begin full-time work?
            <span className="text-red-500 px-1">*</span>
          </p>
          <input className="md:w-[30rem]" />
        </div>
        <div className="md:w-[40rem] border p-2 rounded-md my-2">
          <p className="font-semibold text-sm text-gray-500 mb-2">
            LinkedIn Profile<span className="text-red-500 px-1">*</span>
          </p>
          <input className="md:w-[30rem]" />
        </div>
        <div className="md:w-[40rem] border p-2 rounded-md my-2">
          <p className="font-semibold text-sm text-gray-500 mb-2">Website</p>
          <input className="md:w-[30rem]" />
        </div>
      </div> */}
      <div className="flex gap-2 flex-wrap text-2xl">
        <p className="text-sm text-gray-600">
          Apply: please send us your resume to{" "}
          <a
            href="mailto:contactus@encoreautomation.com"
            className="text-blue-500 underline hover:text-blue-400"
          >
            contactus@encoreautomation.com
          </a>
          .
        </p>
      </div>

      {/* <button
        type="submit"
        className="bg-blue-500 self-start text-white px-20 md:px-40 py-3 rounded-sm hover:bg-blue-400 duration-500 mt-5"
      >
        Submit
      </button> */}
    </div>
  );
}
